export const translations = {
  es: {
    nav: {
      home: "Inicio",
      services: "Servicios",
      pricing: "Precios",
      about: "Sobre Mí",
      contact: "Contacto",
      language: "Idioma"
    },

    hero: {
      title: "Consigue",
      titleHighlight: "más clientes",
      titleEnd: " para tu negocio local con anuncios en Instagram y Facebook",
      subtitle: "Solo founder gestionando campañas de Meta Ads diseñadas para convertir. Soporte opcional de contenido en Instagram para que tu perfil siga vivo mientras los anuncios hacen el trabajo pesado.",
      tagline: "",
      ctaAudit: "🎁 Solicita una auditoría gratis",
      ctaPricing: "Ver precios"
    },

    whatWeDo: {
      title: "Qué",
      titleHighlight: "hago",
      titleEnd: "",
      intro1: "Diriges una empresa y cada día estás ocupado con lo importante: clientes, operaciones y hacer que el negocio funcione.",
      intro2: "Sabes que la publicidad pagada es la forma en que se da el crecimiento serio.",
      intro3: "Pero Meta Ads es un mundo en sí mismo — píxeles, audiencias, funnels, creatividades, optimización — y equivocarse significa quemar dinero rápido.",
      problem: "",
      solution: "Ahí es donde entro yo. Gestiono tus Meta Ads de principio a fin, así no tienes que aprenderlo, gestionarlo ni preocuparte.",
      solutionBold: "Tú consigues más clientes. Yo me centro en lo que sé hacer bien.",
      subtitle: "Lo que obtienes:",
      point1: "Más leads cualificados",
      point2: "Mejor retorno de tu inversión publicitaria",
      point3: "Un perfil que no se queda en silencio",
      result: ""
    },

    services: {
      title: "Mis",
      titleHighlight: "Servicios",
      service1: {
        icon: "🎯",
        title: "Campañas estratégicas de Meta Ads",
        intro: "Esto es el núcleo de lo que hago. No solo publicar anuncios — construir campañas diseñadas para convertir.",
        description: "",
        includesTitle: "Me encargo de:",
        details: [
          "Definir tu cliente ideal y la estrategia de audiencia",
          "Configurar el tracking (Meta Pixel, Conversions API, eventos)",
          "Construir campañas de funnel completo (awareness → consideración → conversión)",
          "Diseñar creatividades publicitarias o pulir tu contenido existente",
          "Lanzar, monitorear y optimizar a diario",
          "Reportar resultados mensualmente con métricas claras"
        ],
        result: "Leads cualificados y clientes reales, no tráfico aleatorio."
      },
      service2: {
        icon: "📱",
        addonLabel: "Add-on opcional",
        title: "Soporte de contenido en Instagram",
        intro: "Un servicio ligero para mantener tu perfil activo mientras los anuncios hacen el trabajo pesado. No es una estrategia de contenido completa — solo lo justo para parecer vivo y alimentar el algoritmo.",
        includesTitle: "Incluye:",
        details: [
          "4 publicaciones diseñadas al mes",
          "4 stories al mes",
          "Captions + hashtags",
          "Tema de contenido mensual básico"
        ]
      },
      cta: "✉️ Solicita tu propuesta personalizada"
    },

    pricing: {
      title: "Precios y",
      titleHighlight: "Packs",
      subtitle: "Planes de Meta Ads diseñados para hacer crecer tu negocio. Cada plan incluye un informe mensual de rendimiento.",
      popular: "Más Popular",
      from: "Desde",
      perMonth: "/mes",
      ctaPlan: "✉️ Solicitar este plan",
      ctaAddon: "✉️ Añadir a mi plan",
      adNote: "La inversión publicitaria se paga por separado, directamente a Meta.",
      recommendedLabel: "Inversión publicitaria recomendada:",
      addonBadge: "Complemento opcional",

      metaCategory: {
        title: "🚀 Gestión de Meta Ads",
        launch: {
          name: "Launch",
          price: "400€",
          tagline: "Para negocios que lanzan sus primeras campañas serias o con presupuestos más pequeños.",
          features: [
            "Configuración completa de cuenta + Meta Pixel",
            "1–2 campañas activas (un único funnel)",
            "3–4 variaciones de creatividad publicitaria",
            "Informe mensual de rendimiento",
            "Soporte por email"
          ],
          recommendedSpend: "500€–1.500€/mes"
        },
        growth: {
          name: "Growth",
          price: "700€",
          tagline: "Para negocios con una oferta probada que quieren escalar sistemáticamente.",
          features: [
            "Todo lo del plan Launch, más:",
            "Múltiples campañas (awareness + conversión)",
            "Pruebas A/B en creatividades, audiencias y copy",
            "6–8 variaciones de creatividad publicitaria al mes",
            "Informe mensual de rendimiento"
          ],
          recommendedSpend: "1.500€–5.000€/mes"
        },
        scale: {
          name: "Scale",
          price: "1000€",
          tagline: "Para negocios establecidos listos para escalar agresivamente.",
          features: [
            "Todo lo del plan Growth, más:",
            "Audiencias personalizadas, lookalikes, retargeting",
            "Trabajo creativo avanzado",
            "Informe mensual de rendimiento"
          ],
          recommendedSpend: "5.000€+/mes"
        }
      },

      addon: {
        name: "Instagram Light",
        price: "150€",
        tagline: "Complemento a cualquier plan de Meta Ads (o por separado) para mantener tu perfil de Instagram activo.",
        features: [
          "4 publicaciones diseñadas al mes",
          "4 stories al mes",
          "Captions + hashtags",
          "Calendario de contenido básico"
        ]
      },

      positioning: {
        title: "⚡ Mi posicionamiento",
        intro: "Soy especialista en Meta Ads enfocado en rendimiento y crecimiento.",
        points: [
          "Diseño campañas publicitarias orientadas a generar leads y clientes",
          "Gestiono y optimizo anuncios en Meta Ads de forma continua",
          "Analizo resultados y mejoro cada campaña para maximizar el retorno",
          "Trabajo codo con codo contigo. Sin gente innecesaria de por medio"
        ]
      }
    },

    audit: {
      title: "🎁 Auditoría",
      titleHighlight: "Gratis",
      subtitle: "Antes de comprometerte con nada, reviso tu configuración de Meta Ads y tu perfil de Instagram y te doy 3 recomendaciones concretas — gratis, sin compromiso.",
      points: [
        "Videollamada de 15 minutos",
        "Revisión honesta de tus anuncios actuales y tu perfil",
        "3 acciones específicas que puedes aplicar de inmediato",
        "Sin pitch comercial, sin spam de follow-up"
      ],
      cta: "Reservar mi auditoría gratis"
    },

    whyUs: {
      title: "¿Por qué trabajar",
      titleHighlight: "conmigo",
      titleEnd: "?",
      subtitle: "Solo founder, decisiones rápidas y atención total a tu cuenta",
      reason1: {
        title: "🚀 Solo founder, totalmente comprometido",
        description: "Llevo a propósito un número reducido de clientes. El tuyo recibe mi atención completa — no lo que sobra después de cien cuentas más."
      },
      reason2: {
        title: "🤝 Trabajas conmigo, directamente",
        description: "Sin account managers, sin juniors, sin traspasos. La persona a la que escribes es la persona que hace el trabajo. Siempre."
      },
      reason3: {
        title: "⚡ Decisiones en minutos, no en reuniones",
        description: "¿Una campaña necesita ajustes? ¿Un anuncio tiene que salir hoy? Sin aprobaciones internas, sin hilos de Slack con cinco departamentos. Simplemente lo hago."
      },
      reason4: {
        title: "🎓 Formado y certificado",
        description: "Actualmente estudio International Business y Marketing. Certificado en Meta Ads y marketing digital. Formación formal combinada con ejecución práctica."
      }
    },

    about: {
      title: "¿Quién",
      titleHighlight: "Soy",
      titleEnd: "?",
      experience: "Certificado en Meta Ads",
      description1: "Soy Pau Asensio, fundador de Pulso Media Agency. Actualmente estudio International Business y Marketing y trabajo desde Barcelona.\n\nCuando contratas Pulso, trabajas directamente conmigo. Yo me encargo de crear tus campañas, gestionar tus anuncios en Meta, optimizarlos cada día y enviarte reportes mensuales con los resultados. Sin intermediarios ni procesos complicados. Comunicación directa, rápida y clara.",
      description2: "Trabajo de esta forma porque creo en un servicio más cercano y personalizado. Eso me permite tomar decisiones rápidas, dedicarle atención real a cada cuenta y ofrecer precios más accesibles que una agencia tradicional.\n\nEstoy construyendo una agencia basada en resultados y confianza, por eso trato cada proyecto como si fuera mío. Tu crecimiento también es el mío.",
      cta: "Más sobre mí",
      ctaLinktree: "🔗 Ver mi Linktree"
    },

    cta: {
      title: "¿Listo para llevar tu marca al siguiente nivel?",
      description: "Contáctame por email o conéctate conmigo en LinkedIn.",
      additionalInfo: "Te responderé en menos de 24 horas.",
      ctaEmail: "✉️ Contacta conmigo",
      ctaLinkedIn: "💼 Ver LinkedIn",
      ctaLinktree: "🔗 Ver mi Linktree"
    },

    contact: {
      title: "Pulso Media Agency",
      description: "Performance Meta Ads para negocios españoles. Solo founder, atención directa, decisiones rápidas.",
      contactTitle: "Contacto",
      followTitle: "Sígueme",
      copyright: "© 2026 Pulso Media Agency. Todos los derechos reservados."
    }
  },

  en: {
    nav: {
      home: "Home",
      services: "Services",
      pricing: "Pricing",
      about: "About Me",
      contact: "Contact",
      language: "Language"
    },

    hero: {
      title: "Get",
      titleHighlight: "more clients",
      titleEnd: " for your local business with Instagram and Facebook ads",
      subtitle: "Solo founder running Meta Ads campaigns built to convert. Optional Instagram content support so your profile stays alive while ads do the heavy lifting.",
      tagline: "",
      ctaAudit: "🎁 Get a free audit",
      ctaPricing: "See pricing"
    },

    whatWeDo: {
      title: "What",
      titleHighlight: "I do",
      titleEnd: "",
      intro1: "You run a business and every day you're busy with what matters: clients, operations, and making the business work.",
      intro2: "You know paid advertising is how serious growth happens.",
      intro3: "But Meta Ads is its own world — pixels, audiences, funnels, creatives, optimization — and getting it wrong means burning money fast.",
      problem: "",
      solution: "That's where I come in. I handle your Meta Ads end to end so you don't have to learn it, manage it, or worry about it.",
      solutionBold: "You get more customers. I get to focus on what I'm good at.",
      subtitle: "What you get:",
      point1: "More qualified leads",
      point2: "Better return on ad spend",
      point3: "A profile that doesn't go silent",
      result: ""
    },

    services: {
      title: "My",
      titleHighlight: "Services",
      service1: {
        icon: "🎯",
        title: "Strategic Meta Ads Campaigns",
        intro: "This is the core of what I do. Not just running ads — building campaigns designed to convert.",
        description: "",
        includesTitle: "I handle:",
        details: [
          "Define your ideal customer and audience strategy",
          "Set up tracking (Meta Pixel, Conversions API, events)",
          "Build full-funnel campaigns (awareness → consideration → conversion)",
          "Design ad creatives or polish your existing content",
          "Launch, monitor, and optimize daily",
          "Report results monthly with clear metrics"
        ],
        result: "Qualified leads and real customers, not random traffic."
      },
      service2: {
        icon: "📱",
        addonLabel: "Optional add-on",
        title: "Instagram Content Support",
        intro: "A light-touch service to keep your profile active while your ads do the heavy lifting. Not a full content strategy — just enough to look alive and feed the algorithm.",
        includesTitle: "Includes:",
        details: [
          "4 designed posts per month",
          "4 story posts per month",
          "Captions + hashtags",
          "Basic monthly content theme"
        ]
      },
      cta: "✉️ Request your personalized proposal"
    },

    pricing: {
      title: "Pricing &",
      titleHighlight: "Packs",
      subtitle: "Meta Ads plans designed to grow your business. Every plan includes a monthly performance report.",
      popular: "Most Popular",
      from: "Starting from",
      perMonth: "/month",
      ctaPlan: "✉️ Request this plan",
      ctaAddon: "✉️ Add to my plan",
      adNote: "Ad spend is paid separately by the client directly to Meta.",
      recommendedLabel: "Recommended client ad spend:",
      addonBadge: "Optional add-on",

      metaCategory: {
        title: "🚀 Meta Ads Management",
        launch: {
          name: "Launch",
          price: "€400",
          tagline: "For businesses running their first serious ad campaigns or with smaller budgets.",
          features: [
            "Full account + Meta Pixel setup",
            "1–2 campaigns running (single funnel)",
            "3–4 ad creative variations",
            "Monthly performance report",
            "Email support"
          ],
          recommendedSpend: "€500–1,500/month"
        },
        growth: {
          name: "Growth",
          price: "€700",
          tagline: "For businesses with a proven offer that want to scale systematically.",
          features: [
            "Everything in Launch, plus:",
            "Multiple campaigns (awareness + conversion)",
            "A/B testing on creatives, audiences, and copy",
            "6–8 ad creative variations per month",
            "Monthly performance report"
          ],
          recommendedSpend: "€1,500–5,000/month"
        },
        scale: {
          name: "Scale",
          price: "€1000",
          tagline: "For established businesses ready to aggressively scale.",
          features: [
            "Everything in Growth, plus:",
            "Custom audiences, lookalikes, retargeting",
            "Advanced creative work",
            "Monthly performance report"
          ],
          recommendedSpend: "€5,000+/month"
        }
      },

      addon: {
        name: "Instagram Light",
        price: "€150",
        tagline: "Add-on to any Meta Ads plan (or standalone) to keep your Instagram profile active.",
        features: [
          "4 designed posts per month",
          "4 story posts per month",
          "Captions + hashtags",
          "Basic content calendar"
        ]
      },

      positioning: {
        title: "⚡ My positioning",
        intro: "I'm a Meta Ads specialist focused on performance and growth.",
        points: [
          "I design ad campaigns aimed at generating leads and customers",
          "I manage and continuously optimize Meta Ads",
          "I analyze results and improve every campaign to maximize ROI",
          "I work side by side with you. No unnecessary people in the middle"
        ]
      }
    },

    audit: {
      title: "🎁 Free",
      titleHighlight: "Audit",
      subtitle: "Before you commit to anything, I'll review your Meta Ads setup and Instagram profile and give you 3 concrete recommendations — for free, no obligation.",
      points: [
        "15-minute video call",
        "Honest review of your current ads and profile",
        "3 specific actions you can implement immediately",
        "No sales pitch, no follow-up spam"
      ],
      cta: "Book my free audit"
    },

    whyUs: {
      title: "Why work",
      titleHighlight: "with me",
      titleEnd: "?",
      subtitle: "Solo founder, fast decisions, full attention on your account",
      reason1: {
        title: "🚀 Solo founder, fully invested",
        description: "I keep a small number of clients on purpose. Yours gets my full attention — not whatever's left over after a hundred other accounts."
      },
      reason2: {
        title: "🤝 You work with me, directly",
        description: "No account managers, no juniors, no handoffs. The person you message is the person doing the work. Always."
      },
      reason3: {
        title: "⚡ Decisions in minutes, not meetings",
        description: "A campaign needs tweaking? An ad needs to go live today? No internal approvals, no Slack threads with five departments. I just do it."
      },
      reason4: {
        title: "🎓 Trained and certified",
        description: "Currently studying International Business and Marketing. Certified in Meta Ads and digital marketing. Formal training paired with hands-on execution."
      }
    },

    about: {
      title: "Who",
      titleHighlight: "Am I",
      titleEnd: "?",
      experience: "Certified in Meta Ads",
      description1: "I'm Pau Asensio, founder of Pulso Media Agency. I'm currently studying International Business and Marketing and working from Barcelona.\n\nWhen you hire Pulso, you work directly with me. I take care of building your campaigns, running your Meta Ads, optimizing them every day and sending you monthly reports with the results. No middlemen, no complicated processes. Direct, fast and clear communication.",
      description2: "I work this way because I believe in a closer, more personalized service. That lets me make fast decisions, give real attention to every account and offer prices more accessible than a traditional agency.\n\nI'm building an agency based on results and trust, so I treat every project like it's my own. Your growth is my growth too.",
      cta: "Learn more about me",
      ctaLinktree: "🔗 View my Linktree"
    },

    cta: {
      title: "Ready to take your brand to the next level?",
      description: "Contact me by email or LinkedIn.",
      additionalInfo: "I'll respond within 24 hours.",
      ctaEmail: "✉️ Contact me",
      ctaLinkedIn: "💼 View LinkedIn",
      ctaLinktree: "🔗 View my Linktree"
    },

    contact: {
      title: "Pulso Media Agency",
      description: "Performance Meta Ads for Spanish businesses. Solo founder, direct attention, fast decisions.",
      contactTitle: "Contact",
      followTitle: "Follow Me",
      copyright: "© 2026 Pulso Media Agency. All rights reserved."
    }
  },

  cs: {
    nav: {
      home: "Domů",
      services: "Služby",
      pricing: "Ceny",
      about: "O mně",
      contact: "Kontakt",
      language: "Jazyk"
    },

    hero: {
      title: "Získej",
      titleHighlight: "více zákazníků",
      titleEnd: " pro svůj místní byznys s reklamami na Instagramu a Facebooku",
      subtitle: "Solo founder spravující Meta Ads kampaně postavené na konverze. Volitelná podpora Instagram obsahu, aby váš profil zůstal živý, zatímco reklamy odvádějí těžkou práci.",
      tagline: "",
      ctaAudit: "🎁 Získat audit zdarma",
      ctaPricing: "Zobrazit ceny"
    },

    whatWeDo: {
      title: "Co",
      titleHighlight: "dělám",
      titleEnd: "",
      intro1: "Vedete firmu a každý den jste zaneprázdněni tím, co je důležité: klienty, provozem a tím, aby byznys fungoval.",
      intro2: "Víte, že placená reklama je způsob, jakým dochází k vážnému růstu.",
      intro3: "Ale Meta Ads je svět sám o sobě — pixely, publika, funnely, kreativy, optimalizace — a udělat to špatně znamená rychle spálit peníze.",
      problem: "",
      solution: "Tady přicházím já. Spravuji vaše Meta Ads od začátku do konce, takže se to nemusíte učit, řídit ani se o to starat.",
      solutionBold: "Vy získáte více zákazníků. Já se soustředím na to, v čem jsem dobrý.",
      subtitle: "Co získáte:",
      point1: "Více kvalifikovaných leadů",
      point2: "Lepší návratnost reklamní investice",
      point3: "Profil, který nezmlkne",
      result: ""
    },

    services: {
      title: "Moje",
      titleHighlight: "Služby",
      service1: {
        icon: "🎯",
        title: "Strategické Meta Ads kampaně",
        intro: "Toto je jádro toho, co dělám. Nejde jen o spouštění reklam — jde o budování kampaní navržených ke konverzím.",
        description: "",
        includesTitle: "Postarám se o:",
        details: [
          "Definování vašeho ideálního zákazníka a strategie publika",
          "Nastavení trackingu (Meta Pixel, Conversions API, události)",
          "Sestavení kampaní celého funnelu (awareness → consideration → conversion)",
          "Návrh reklamních kreativ nebo dolaďování vašeho stávajícího obsahu",
          "Spouštění, monitoring a denní optimalizace",
          "Měsíční reportování výsledků s jasnými metrikami"
        ],
        result: "Kvalifikované leady a skuteční zákazníci, ne náhodný provoz."
      },
      service2: {
        icon: "📱",
        addonLabel: "Volitelný doplněk",
        title: "Podpora Instagram obsahu",
        intro: "Lehká služba, která udrží váš profil aktivní, zatímco reklamy odvádějí těžkou práci. Není to plnohodnotná obsahová strategie — jen tolik, aby profil vypadal živě a sytil algoritmus.",
        includesTitle: "Zahrnuje:",
        details: [
          "4 navržené příspěvky měsíčně",
          "4 příspěvky do Stories měsíčně",
          "Popisky + hashtagy",
          "Základní měsíční téma obsahu"
        ]
      },
      cta: "✉️ Vyžádejte si personalizovanou nabídku"
    },

    pricing: {
      title: "Ceny &",
      titleHighlight: "Balíčky",
      subtitle: "Plány Meta Ads navržené pro růst vašeho byznysu. Každý plán obsahuje měsíční report výkonu.",
      popular: "Nejoblíbenější",
      from: "Od",
      perMonth: "/měsíc",
      ctaPlan: "✉️ Vyžádat tento plán",
      ctaAddon: "✉️ Přidat k mému plánu",
      adNote: "Náklady na reklamu hradí klient odděleně přímo společnosti Meta.",
      recommendedLabel: "Doporučená reklamní investice klienta:",
      addonBadge: "Volitelný doplněk",

      metaCategory: {
        title: "🚀 Správa Meta Ads",
        launch: {
          name: "Launch",
          price: "10 000 CZK",
          tagline: "Pro firmy, které spouštějí své první vážné reklamní kampaně nebo mají menší rozpočty.",
          features: [
            "Kompletní nastavení účtu + Meta Pixel",
            "1–2 aktivní kampaně (jeden funnel)",
            "3–4 varianty reklamních kreativ",
            "Měsíční report výkonu",
            "E-mailová podpora"
          ],
          recommendedSpend: "12 500–37 500 CZK/měsíc"
        },
        growth: {
          name: "Growth",
          price: "17 500 CZK",
          tagline: "Pro firmy s ověřenou nabídkou, které chtějí systematicky škálovat.",
          features: [
            "Vše z plánu Launch, plus:",
            "Více kampaní (awareness + konverze)",
            "A/B testování kreativ, publik a textů",
            "6–8 variant reklamních kreativ měsíčně",
            "Měsíční report výkonu"
          ],
          recommendedSpend: "37 500–125 000 CZK/měsíc"
        },
        scale: {
          name: "Scale",
          price: "25 000 CZK",
          tagline: "Pro etablované firmy připravené agresivně škálovat.",
          features: [
            "Vše z plánu Growth, plus:",
            "Vlastní publika, lookalikes, retargeting",
            "Pokročilá kreativní práce",
            "Měsíční report výkonu"
          ],
          recommendedSpend: "125 000+ CZK/měsíc"
        }
      },

      addon: {
        name: "Instagram Light",
        price: "3 750 CZK",
        tagline: "Doplněk k jakémukoli plánu Meta Ads (nebo samostatně) pro udržení aktivního profilu na Instagramu.",
        features: [
          "4 navržené příspěvky měsíčně",
          "4 příspěvky do Stories měsíčně",
          "Popisky + hashtagy",
          "Základní obsahový kalendář"
        ]
      },

      positioning: {
        title: "⚡ Moje pozicování",
        intro: "Jsem specialista na Meta Ads zaměřený na výkon a růst.",
        points: [
          "Navrhuji reklamní kampaně zaměřené na získávání leadů a zákazníků",
          "Spravuji a průběžně optimalizuji reklamy v Meta Ads",
          "Analyzuji výsledky a vylepšuji každou kampaň pro maximální návratnost",
          "Pracuji s vámi bok po boku. Bez zbytečných lidí mezi námi"
        ]
      }
    },

    audit: {
      title: "🎁 Audit",
      titleHighlight: "zdarma",
      subtitle: "Než se k čemukoli zavážete, projdu si vaše nastavení Meta Ads a profil na Instagramu a dám vám 3 konkrétní doporučení — zdarma, bez závazku.",
      points: [
        "15minutový videohovor",
        "Upřímná revize vašich současných reklam a profilu",
        "3 konkrétní akce, které můžete okamžitě implementovat",
        "Bez prodejního pitche, bez spamu na follow-up"
      ],
      cta: "Rezervovat audit zdarma"
    },

    whyUs: {
      title: "Proč pracovat",
      titleHighlight: "se mnou",
      titleEnd: "?",
      subtitle: "Solo founder, rychlá rozhodnutí a plná pozornost vašemu účtu",
      reason1: {
        title: "🚀 Solo founder, plně investovaný",
        description: "Záměrně si udržuji malý počet klientů. Ten váš dostává mou plnou pozornost — ne to, co zbyde po sto dalších účtech."
      },
      reason2: {
        title: "🤝 Pracujete přímo se mnou",
        description: "Žádní account manažeři, žádní junioři, žádné předávky. Osoba, které píšete, je osoba, která dělá práci. Vždy."
      },
      reason3: {
        title: "⚡ Rozhodnutí v minutách, ne na schůzkách",
        description: "Kampaň potřebuje úpravu? Reklama musí jít dnes ven? Žádné interní schvalování, žádná Slack vlákna s pěti odděleními. Prostě to udělám."
      },
      reason4: {
        title: "🎓 Vzdělaný a certifikovaný",
        description: "Momentálně studuji International Business a Marketing. Certifikovaný v Meta Ads a digitálním marketingu. Formální vzdělání doplněné praktickou exekucí."
      }
    },

    about: {
      title: "Kdo",
      titleHighlight: "jsem",
      titleEnd: "?",
      experience: "Certifikovaný v Meta Ads",
      description1: "Jsem Pau Asensio, zakladatel Pulso Media Agency. Momentálně studuji International Business a Marketing a pracuji z Barcelony.\n\nKdyž najmete Pulso, pracujete přímo se mnou. Já mám na starosti tvorbu vašich kampaní, správu vašich reklam na Meta, jejich každodenní optimalizaci a zasílání měsíčních reportů s výsledky. Žádní prostředníci, žádné složité procesy. Přímá, rychlá a jasná komunikace.",
      description2: "Pracuji tímto způsobem, protože věřím v bližší a personalizovanější službu. To mi umožňuje rychle se rozhodovat, věnovat každému účtu skutečnou pozornost a nabízet dostupnější ceny než tradiční agentura.\n\nBuduji agenturu založenou na výsledcích a důvěře, proto se ke každému projektu chovám, jako by byl můj. Váš růst je i můj růst.",
      cta: "Více o mně",
      ctaLinktree: "🔗 Zobrazit můj Linktree"
    },

    cta: {
      title: "Jste připraveni posunout vaši značku na další úroveň?",
      description: "Kontaktujte mě emailem nebo na LinkedInu.",
      additionalInfo: "Odpovím vám do 24 hodin.",
      ctaEmail: "✉️ Kontaktuj mě",
      ctaLinkedIn: "💼 Zobrazit LinkedIn",
      ctaLinktree: "🔗 Zobrazit můj Linktree"
    },

    contact: {
      title: "Pulso Media Agency",
      description: "Výkonnostní Meta Ads pro španělské firmy. Solo founder, přímá pozornost, rychlá rozhodnutí.",
      contactTitle: "Kontakt",
      followTitle: "Sledujte mě",
      copyright: "© 2026 Pulso Media Agency. Všechna práva vyhrazena."
    }
  }
};
